import * as React from 'react';

function FilterMenu(props)  {

    let services = ["ALL"];
    //const [value, setValue] = React.useState('ALL');
    const handleChange = (event) => {
        props.onSelectedService(event.target.value)
    };

    if (props.services.size !== undefined) {
        services = [...services, ...(Array.from((props.services).keys()))]
    }

    return (
        <>
            <p>Select API Group: &nbsp;</p>
            <select value={props.selectedService} onChange={handleChange} title={'Select API Group'}>{
                services.sort().map( (s) =>
                    <option value={s} key={s}>{s}</option> )
            }</select>
            <p>&nbsp;(Experimental)</p>
        </>
    );
}



export default FilterMenu;